var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          attrs: {
            width: 760,
            visible: _vm.visible,
            centered: true,
            wrapClassName: "news-modal-wrap",
            bodyStyle: { padding: "0" },
          },
          on: { cancel: _vm.handleCancel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      staticClass: "news-modal-close-btn",
                      on: { click: _vm.handleCancel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.close")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "news-modal-hero" }, [
            _c("div", { staticClass: "news-modal-hero__glow" }),
            _vm._v(" "),
            _c("div", { staticClass: "news-modal-hero__content" }, [
              _c(
                "div",
                { staticClass: "news-modal-hero__logo" },
                [_c("SupsisNewLogo")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "news-modal-hero__text" }, [
                _c("h2", { staticClass: "news-modal-hero__title" }, [
                  _vm._v(_vm._s(_vm.$t("message.newsModalTitle"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "news-modal-hero__subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("message.newsModalSubtitle"))),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "news-modal-body" },
            _vm._l(_vm.newsItems, function (item, index) {
              return _c("ItemNewsModal", {
                key: index,
                attrs: {
                  title: item.title,
                  ticket: item.ticket,
                  description: item.description,
                  newsLink: item.newsLink,
                  date: item.date,
                  linkText: item.linkText,
                  ribbonText: item.ribbonText,
                  mediaUrl: item.mediaUrl,
                  "on-click": item.onClick,
                  "on-clicked": _vm.handleCancel,
                },
              })
            }),
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }